import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoAgilePurchase's component.
 */
const InfoAgilePurchaseBySector = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-InfoAgilePurchaseBySector.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el o los sectores del Estado que requieras visualizar.</Item>
        <Item>Selecciona el indicador, puede ser monto u órdenes de compra.</Item>
        <Item>Selecciona la distribución mensual o acumulada.</Item>
        <Item>Corresponde al indicador seleccionado.</Item>
        <Item>Cada color de la linea corresponde a un sector del estado.</Item>
        <Item>Corresponde a los meses del año seleccionado.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoAgilePurchaseBySector
